const routes = [
  {
    path: "",
    name: "Dashboard",
    meta: { auth: true, roles: ["company", "admin", "user"] },
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../view/pages/Dashboard.vue"),
  },
  {
    path: "add-admin",
    name: "AddAdmin",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "add user" */ "@/view/apps/admin/AddAdmin.vue"
      ),
  },
  {
    path: "adminlist",
    name: "adminList",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "add user" */ "@/view/apps/admin/AdminList.vue"
      ),
  },
  {
    path: "application-tracking",
    name: "ApplicationTracking",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "add user" */ "../view/apps/admin/CandidateJobApplied.vue"
      ),
  },
  {
    path: "sync-company",
    name: "SyncCompany",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "add user" */ "../components/admins/SyncCompany"
      ),
  },

  {
    path: "sync-candidate",
    name: "SyncCandidate",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "add user" */ "../components/admins/SyncCandidate"
      ),
  },

  {
    path: "companies",
    name: "Companies",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },

    component: () =>
      import(
        /* webpackChunkName: "companies" */ "../view/apps/companies/Companies.vue"
      ),
  },
{
    path: "/companies-list",
    name: "CompaniesList",
    meta: { auth: true, requiresAdmin: true, roles: ["user"] },

    component: () =>
      import(
        /* webpackChunkName: "companies" */ "../view/apps/companies/CompaniesPublic.vue"
      ),
  },
  {
    path: "/companies/add-company",
    name: "AddCompany",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "add company" */ "../view/apps/companies/AddCompany.vue"
      ),
  },

  {
    path: "import",
    name: "Import",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "adminlist" */ "../view/apps/importExport/Import.vue"
      ),
  },

  {
    path: "imports",
    name: "Import",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "adminlist" */ "../view/apps/importExport/ImportList.vue"
      ),
  },
  {
    path: "candidates",
    name: "Candidates",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/candidates/Candidates.vue"
      ),
  },
  {
    path: "candidates/add-candidate",
    name: "AddCandidate",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/candidates/AddCandidate.vue"
      ),
  },
  {
    path: "candidates/:id",
    name: "CandidateDetail",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/candidates/CandidateDetail.vue"
      ),
  },

  {
    path: "adminlist/:id",
    name: "AdminDetails",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/admin/AdminDetails.vue"
      ),
  },

  {
    path: "companies/:id",
    name: "CompanyDetail",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/companies/CompanyDetail.vue"
      ),
  },

  {
    path: "settings",
    name: "Settings",
    meta: {
      auth: true,
      requiresAdmin: true,
      roles: ["admin", "user", "company"],
    },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/settings/Settings.vue"
      ),

    children: [
      {
        path: "reset-password",
        name: "reset-password",
        meta: {
          auth: true,
          requiresAdmin: true,
          roles: ["admin", "user", "company"],
        },
        component: () =>
          import(
            /* webpackChunkName: "candidates" */ "../view/apps/settings/overview/Password.vue"
          ),
      },
      {
        path: "change-username",
        name: "change-username",
        meta: {
          auth: true,
          requiresAdmin: true,
          roles: ["admin", "user", "company"],
        },
        component: () =>
          import(
            /* webpackChunkName: "Password" */ "../view/apps/settings/overview/EditUsername.vue"
          ),
      },
      {
        path: "edit-company-profile",
        name: "company-profile",
        meta: {
          auth: true,
          roles: ["company"],
        },
        component: () =>
          import(
            /* webpackChunkName: "candidates" */ "../view/apps/settings/overview/CompanyProfile.vue"
          ),
      },
      {
        path: "edit-user-profile",
        name: "user-profile",
        meta: {
          auth: true,
          roles: ["user"],
        },
        component: () =>
          import(
            /* webpackChunkName: "candidates" */ "../view/apps/settings/overview/CandidateProfile.vue"
          ),
      },
    ],
  },

  {
    path: "skill-list",
    name: "skillsList",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () => import(/*..*/ "../view/apps/glob/overview/SkillsList.vue"),
  },

  {
    path: "company-insights",
    name: "CompanyInsights",
    meta: { auth: true, requiresAdmin: true, roles: ["company"] },
    component: () =>
      import(/*..*/ "../view/apps/glob/overview/CompanyInsights.vue"),
  },

  // Edit Data Pages
  {
    path: "sector",
    name: "Sector",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },
  {
    path: "job-post-category",
    name: "Job Post Category",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },
  {
    path: "employee-range",
    name: "Employee Range",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EmployeeRange.vue"),
  },

  {
    path: "/certification-field",
    name: "Certification Field",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "category",
    name: "Category",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "industry",
    name: "Industry",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "function",
    name: "Function",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "department",
    name: "Department",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "service",
    name: "Service",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "study-field",
    name: "Study Field",
    roles: ["admin"],
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "city",
    name: "City",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/editDataPages/EditDataPage.vue"),
  },

  {
    path: "add-skill",
    name: "addSkill",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () => import(/*..*/ "../view/apps/glob/overview/AddSkill.vue"),
  },
  {
    path: "data-insights",
    name: "dataInsights",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () => import(/*..*/ "../view/apps/insights/DataInsights.vue"),
  },
  {
    path: "add-insight",
    name: "addInsight",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/insights/overview/AddInsight.vue"),
  },
  {
    path: "data-insights/:id",
    name: "editInsight",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(/*..*/ "../view/apps/insights/overview/EditInsight.vue"),
  },
  // {
  //   path: "/data-insights/:id",
  //   name: "dataInsights",
  //   meta: { auth: true, requiresAdmin: true },
  //   component: () => import(/*..*/ "../view/apps/insights/DataInsightsDetail.vue"),
  // },
  {
  path: "/job-posts",
    name: "jobPost",
    meta: { auth: true, requiresAdmin: true, roles: ["admin"] },
    component: () => import(/*..*/ "../view/apps/jobpost/JobPosts.vue"),
  },

  {
    path: "/job-posts/:id",
    name: "jobPosts",
    meta: { requiresAdmin: true, roles: ["admin"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/jobpost/JobDetails.vue"
      ),
  },

  {
    path: "/job-posts/add-job",
    name: "AddJob",
    meta: { requiresAdmin: true, roles: ["admin"] },

    component: () =>
      import(
        /* webpackChunkName: "add user" */ "@/view/apps/jobpost/AddJob.vue"
      ),
  },

  //companies view
  {
    path: "/view-candidates",
    name: "candidatesCompany",
    meta: { auth: true, requiresAdmin: true, roles: ["company"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/candidates/Candidates.vue"
      ),
  },

  {
    path: "/job-candidate-list",
    name: "jobCandidateList",
    meta: { auth: true, requiresAdmin: true, roles: ["company"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/admin/CandidateJobApplied.vue"
      ),
  },

  {
    path: "/view-job-posts",
    name: "CandidatesCompany",
    meta: { auth: true, requiresAdmin: true, roles: ["company"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/companies/ListJobPosts.vue"
      ),
  },

  {
    path: "/view-job-posts/:id",
    name: "JobPostDetail",
    meta: { auth: true, requiresAdmin: true, roles: ["company", 'user'] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/jobpost/JobPostDetail.vue"
      ),
  },

  //candidates view
  {
    path: "/candidate/view-jobposts",
    name: "CandidateViewJobPosts",
    meta: { auth: true, requiresAdmin: true, roles: ["user"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/companies/ListJobPosts.vue"
      ),
  },
  {
    path: "/candidate/view-jobposts/:id",
    name: "CandidateJobPostDetail",
    meta: { auth: true, requiresAdmin: true, roles: ["user"] },
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/jobpost/JobPostDetail.vue"
      ),
  },
  {
    path: "/view-applied-jobs",
    name: "viewAppliedJobs",
    meta: { auth: true, requiresAdmin: true, roles: ["user"] },
    // role:['company'],
    component: () =>
      import(
        /* webpackChunkName: "candidates" */ "../view/apps/candidatesComp/CandidatesAppliedJobs.vue"
      ),
  },
];

export default routes;
